import { Component, type ReactNode } from 'react';

interface State {
  err: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  override componentDidCatch(err: Error): void {
    console.error('[ErrorBoundary]', err);
  }

  override render(): ReactNode {
    if (this.state.err) {
      return (
        <div
          role="alert"
          style={{
            padding: 32,
            color: 'var(--c-blood)',
            fontFamily: 'var(--f-mono)',
            background: 'var(--c-void)',
            height: '100%',
          }}
        >
          <h2 style={{ color: 'var(--c-fg)' }}>something snapped</h2>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{this.state.err.message}</pre>
          <button
            type="button"
            onClick={() => location.reload()}
            style={{
              marginTop: 16,
              padding: '12px 20px',
              borderRadius: 'var(--radius)',
              background: 'var(--g-mog)',
              color: 'var(--c-void)',
              fontWeight: 700,
            }}
          >
            reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
